import { useCustomEventsQueryContext } from 'modules/customEvents/contexts';
import { INGESTION_POLICIES } from 'modules/customEvents/types';
import { configuredIngestionPolicy, sortCustomEvents } from 'modules/customEvents/utils';
import { useSearchParamsContext } from 'modules/dataDictionary/contexts';
import { paginate } from 'utils/arrayHelpers';
import { usePaginationContext } from 'utils/contexts/pagination';
import { useSortingContext } from 'utils/contexts/sorting';

export const useCustomEventsTable = () => {
  /**
   * Contexts
   */
  const { customEvents = [], isLoadingCustomEvents } = useCustomEventsQueryContext();

  const { sortBy, sortDirection } = useSortingContext();
  const { debouncedSearch, ingestionPolicy, journeyTriggers } = useSearchParamsContext();
  const { currentPage, pageSize: itemsPerPage } = usePaginationContext();

  /**
   * Filter, sorting and pagination
   */
  const filteredResults = customEvents.filter((event) => {
    const isAllIngesetionPolicy = ingestionPolicy === INGESTION_POLICIES.toString();
    const isIngestionPolicyMatch =
      isAllIngesetionPolicy || ingestionPolicy === configuredIngestionPolicy(event);
    const isNameMatch = event.eventName.toLowerCase().includes(debouncedSearch.toLowerCase());
    const isJourneyTriggerMatch =
      journeyTriggers.length > 0 ? event.workflowTriggers.length > 0 : true;
    return isIngestionPolicyMatch && isNameMatch && isJourneyTriggerMatch;
  });

  const sortedResults = sortCustomEvents(filteredResults, sortBy, sortDirection);

  const paginatedResults = paginate(sortedResults, itemsPerPage, currentPage);

  /**
   * Return
   */
  return {
    isLoading: isLoadingCustomEvents,
    filteredResults,
    paginatedSortedEvents: paginatedResults,
    sortedEvents: sortedResults,
  };
};
